import type { BLOCK_TYPE } from '../enums'

import type { IBlock, BlockBaseSettings } from './base'

/**
 * The value of a given App argument provided by the Configuring user.
 */
export type AppBlockArgumentValue = unknown

/**
 * Map of arguments provided to the App according to their definition and values
 * entrered by the Configuring user.
 */
export type AppBlockArguments = {
  [key: string]: AppBlockArgumentValue
}

/**
 * Expresses {@link AppBlockArguments} as a stringified JSON object.
 * @deprecated soon to be removed since there is no need to save as strings
 */
export type StringifiedAppBlockArguments = string

export enum AppType {
  /**
   * CustomBlock is a block in journey which allows customers to render a custom app/api/sdk in the journey
   * This block can be indenfied in the previous version with type: CustomBlockControl.
   *
   * @deprecated: The Custom Block is deprecated and customers should move to App.
   * The reason this cannot be removed is because we have customers using this block.
   * This data structure supports both types but migrates the schema to App block.
   * The custom block allows external JS which weakens our security. This has been solved with Apps.
   *
   * As of April 3, 2025 we have 7 journeys using this block.
   */
  CUSTOM_BLOCK = 'custom-block',
  INSTALLED_APP = 'installed-app'
}

export interface SharedSettings {
  type: AppType
  bundleURL?: string
  /**
   * Tag name displayed in Journey Builder
   * Example: vanilla-js
   */
  tag?: string
  /**
   * Configuration for the app
   */
  args?: string
}

export interface IAppBlock extends IBlock {
  type: BLOCK_TYPE.APP
  required: false
  settings: BlockBaseSettings & {}
}

export interface InstalledAppBlock extends IAppBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      /**
       * When the block is an App
       */
      type: AppType.INSTALLED_APP
      /**
       * Unique ID of the installed name
       */
      appId?: string
      /**
       * An app consists of multiple components, the componentId in this case
       * would be the ID of the journey block component of the app
       *
       * Other components would be ecp extensions, automation action (not supported yet), etc.
       */
      componentId?: string
    }
}

export interface CustomBlock extends IAppBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      type: AppType.CUSTOM_BLOCK
    }
}

export type AppBlock = InstalledAppBlock | CustomBlock
